/* The CRM and sales-tool integrations, in one register. v2.

   ONE LIST, TWO SURFACES. The strip low on the homepage and the grid on
   /pages/integrations are both built from the array below, so the two can never
   disagree about what Rockkt connects to. Add a tool here and it appears in
   both, and every count on the page follows it.

   WHY THE HOMEPAGE STRIP IS BUILT AT RUN TIME. templates/index.liquid is 236KB
   and past what the Admin API will replace as text, so nothing can be added to
   the homepage at source through this route. Same reason the button band, the
   hero copy and the Studio flip are all injected rather than written in - see
   the notes in layout/rockkt.liquid.

   ── WHAT CHANGED FROM v1 ────────────────────────────────────────
   v1 shipped with no logo files at all: every tile drew the vendor's name set
   in Rockkt's own type, and the note here said twelve wordmarks read better
   than six logos beside six missing images. Glen supplied all twelve marks, so
   all twelve now draw. Two things follow:

     1. Every `ratio` below is now MEASURED off the file that ships, not
        inherited from a vendor's published dimensions. Five of v1's six were
        close; none was exact, because each file is trimmed of its own
        whitespace before it is sized (see the note on `ratio`).

     2. Each entry can carry `h`, an optical height multiplier - new in v2 and
        the reason this file is versioned rather than patched. See below.

   ── WHY `h` EXISTS, AND WHY IT REPLACED A BOOLEAN ───────────────────────
   Sizing every mark to one height makes a squat logo tower over a long one, so
   v1 gave anything under 2:1 a single fixed boost (`is-tall`). That is enough
   for two shapes and not for five. The twelve here are:

     a plain wordmark           hubspot, pipedrive, copper, attio, apollo
     a mark beside a word       capsule, freshsales, close
     a mark above a word        monday.com
     a word inside a shape      salesforce
     two stacked lines          zoho CRM, Microsoft Dynamics 365

   A two-line lockup at a one-line height is unreadable - Dynamics sets nine
   words in the space HubSpot sets one - and Salesforce's cloud is mostly empty
   blue, so it reads small at any height that suits a wordmark. `h` is a
   multiplier on the base height, so each of those five shapes is given the
   height its own construction needs. The values below were set by rendering all
   thirteen tiles at the real strip and card sizes and looking at them, not by
   arithmetic.

   `ratio` is the shipped file's width divided by its height, and is what makes
   marks of different shapes read at the same weight: a mark is sized by its
   WIDTH, derived from this, so a squat one and a long one look equal. Sizing by
   height does not achieve that. It must be measured AFTER trimming, because the
   file that ships is trimmed - a vendor's published PNG is usually padded, and
   its nominal ratio describes the padding as much as the mark.

   Neither number is a style. Both describe the FILE, which is why they live
   here with the file's id rather than in the stylesheet. */
(function () {
  /* ratio = trimmed width / trimmed height, measured off assets/rockkt-int-<id>.png
     h     = optical height multiplier, 1 unless the mark's construction needs more */
  window.RK_INTEGRATIONS = [
    { id: 'hubspot',    name: 'HubSpot',     ratio: 3.525 },
    { id: 'salesforce', name: 'Salesforce',  ratio: 1.431, h: 1.90 },
    { id: 'pipedrive',  name: 'Pipedrive',   ratio: 4.588 },
    { id: 'dynamics',   name: 'Dynamics 365',ratio: 2.862, h: 1.82 },
    { id: 'zoho',       name: 'Zoho CRM',    ratio: 3.137, h: 1.36 },
    { id: 'monday',     name: 'monday.com',  ratio: 1.716, h: 1.73 },
    { id: 'copper',     name: 'Copper',      ratio: 4.906 },
    { id: 'close',      name: 'Close',       ratio: 3.694, h: 1.09 },
    { id: 'attio',      name: 'Attio',       ratio: 3.987 },
    { id: 'capsule',    name: 'Capsule CRM', ratio: 4.225, h: 1.18 },
    { id: 'freshsales', name: 'Freshsales',  ratio: 4.638 },
    { id: 'apollo',     name: 'Apollo',      ratio: 3.797 }
  ];

  /* The last tile is not a tool. It says the list is not a limit. */
  window.RK_INTEGRATIONS_CUSTOM = 'Custom on request';
})();
